<template>
  <Loading></Loading>
  <Header></Header>
  <router-view v-slot="{ Component, route }">
    <keep-alive>
      <component :key="route.name" :is="Component" />
    </keep-alive>
  </router-view>
  <Popup></Popup>
</template>
<script setup>
import Header from './components/common/Header.vue'
import Popup from './components/common/Popup.vue'
import Loading from './components/common/Loading.vue'
import entryHook from '@/hooks/entryHook.ts';
entryHook();
</script>
<style scoped>
</style>
